import { useTranslation } from "react-i18next";
import {
  SFEnergyTitle,
  SFEnergyDesc,
  SFEnergyBenefit1,
  SFEnergyBenefit3,
  SFEnergyBenefit2,
  SFImmuneSystemTitle,
  SFImmuneSystemDesc,
  SFImmuneSystemBenefit1,
  SFImmuneSystemBenefit3,
  SFImmuneSystemBenefit2,
  SFBeautyTitle,
  SFBeautyDesc,
  SFBeautyBenefit1,
  SFBeautyBenefit3,
  SFBeautyBenefit2,
  SFSleepTitle,
  SFSleepDesc,
  SFSleepBenefit1,
  SFSleepBenefit3,
  SFSleepBenefit2,
  SFSportsRecoveryTitle,
  SFSportsRecoveryDesc,
  SFSportsRecoveryBenefit1,
  SFSportsRecoveryBenefit3,
  SFSportsRecoveryBenefit2,
  SFStressTitle,
  SFStressDesc,
  SFStressBenefit1,
  SFStressBenefit3,
  SFStressBenefit2,
  EnergyFA,
  SleepFA,
  StressFA,
  SportsFA,
  BeautyFA,
  ImmuneSystemFA,
} from "../Constants";
import HowToTakeImage from "../assets/smart-formulas/how-to-take.webp";
import HowToTakeImageDe from "../assets/smart-formulas/how-to-take-de.webp";
import ReviewImage from "../assets/smart-formulas/review.webp";
import ReviewImageDe from "../assets/smart-formulas/review-de.webp";

import EnergyImage2 from "../assets/smart-formulas/energy-2.webp";
import EnergyImage2De from "../assets/smart-formulas/energy-2de.webp";

import ImmuneImage2 from "../assets/smart-formulas/immune-2.webp";
import ImmuneImage2De from "../assets/smart-formulas/immune-2de.webp";
import ImmuneImage3 from "../assets/smart-formulas/immune-3.webp";
import ImmuneImage3De from "../assets/smart-formulas/immune-3de.webp";

import SleepImage2 from "../assets/smart-formulas/sleep-2.webp";
import SleepImage2De from "../assets/smart-formulas/sleep-2de.webp";

import StressImage2 from "../assets/smart-formulas/stress-2.webp";
import StressImage2De from "../assets/smart-formulas/stress-2de.webp";

import SportsImage2 from "../assets/smart-formulas/sports-2.webp";
import SportsImage2De from "../assets/smart-formulas/sports-2de.webp";

import BeautyImage2 from "../assets/smart-formulas/beauty-2.webp";
import BeautyImage2De from "../assets/smart-formulas/beauty-2de.webp";

import Energy from "../assets/smart-formulas/energy.webp";
import Stress from "../assets/smart-formulas/stress.webp";
import Sleep from "../assets/smart-formulas/sleep.webp";
import Beauty from "../assets/smart-formulas/beauty.webp";
import ImmuneSystem from "../assets/smart-formulas/immune-system.webp";
import Performance from "../assets/smart-formulas/sport.webp";

import {
  BEAUTY_INGREDIENTS,
  ENERGY_INGREDIENTS,
  IMMUNE_SYSTEM_INGREDIENTS,
  SLEEP_INGREDIENTS,
  SPORT_RECOVERY_INGREDIENTS,
  STRESS_INGREDIENTS,
} from "../Data/smart-formula";

const useSmartFornula = () => {
  const { t } = useTranslation();
  const SMART_FORMULAS = {
    energy: {
      name: t(EnergyFA),
      images: [
        { en: Energy, de: Energy },
        { en: EnergyImage2, de: EnergyImage2De },
        { en: ReviewImage, de: ReviewImageDe },
        { en: HowToTakeImage, de: HowToTakeImageDe },
      ],
      heading: t(SFEnergyTitle),
      desc: t(SFEnergyDesc),
      price: 49,
      link: "https://buy.stripe.com/00g9BU4M3evz9m82nO",
      benefits: [
        {
          desc: t(SFEnergyBenefit1),
        },
        {
          desc: t(SFEnergyBenefit2),
        },
        {
          desc: t(SFEnergyBenefit3),
        },
      ],
      ingredients: ENERGY_INGREDIENTS,
      howToTake: [
        "One pouch a day, once a day, that's it!",
        "You can take it directly in your mouth followed by a sip of water or mix it with a yoghurt!",
      ],
    },
    sleep: {
      name: t(SleepFA),
      images: [
        { en: Sleep, de: Sleep },
        { en: SleepImage2, de: SleepImage2De },
        { en: ReviewImage, de: ReviewImageDe },
        { en: HowToTakeImage, de: HowToTakeImageDe },
      ],
      heading: t(SFSleepTitle),
      desc: t(SFSleepDesc),
      price: 49,
      link: "https://buy.stripe.com/5kAaFYbar9bf1TGgeF",
      benefits: [
        {
          desc: t(SFSleepBenefit1),
        },
        {
          desc: t(SFSleepBenefit2),
        },
        {
          desc: t(SFSleepBenefit3),
        },
      ],
      ingredients: SLEEP_INGREDIENTS,
      howToTake: [
        "One pouch a day, once a day, that's it!",
        "You can take it directly in your mouth followed by a sip of water or mix it with a yoghurt!",
      ],
    },
    stress: {
      name: t(StressFA),
      images: [
        { en: Stress, de: Stress },
        { en: StressImage2, de: StressImage2De },
        { en: ReviewImage, de: ReviewImageDe },
        { en: HowToTakeImage, de: HowToTakeImageDe },
      ],
      heading: t(SFStressTitle),
      desc: t(SFStressDesc),
      price: 59,
      link: "https://buy.stripe.com/aEUg0ibarbjn9m8e6y",
      benefits: [
        {
          desc: t(SFStressBenefit1),
        },
        {
          desc: t(SFStressBenefit2),
        },
        {
          desc: t(SFStressBenefit3),
        },
      ],
      ingredients: STRESS_INGREDIENTS,
      howToTake: [
        "One pouch a day, once a day, that's it!",
        "You can take it directly in your mouth followed by a sip of water or mix it with a yoghurt!",
      ],
    },
    performance: {
      name: t(SportsFA),
      images: [
        { en: Performance, de: Performance },
        { en: SportsImage2, de: SportsImage2De },
        { en: ReviewImage, de: ReviewImageDe },
        { en: HowToTakeImage, de: HowToTakeImageDe },
      ],
      heading: t(SFSportsRecoveryTitle),
      desc: t(SFSportsRecoveryDesc),
      price: 69,
      link: "https://buy.stripe.com/00gg0i3HZbjnfKw0fJ",
      benefits: [
        {
          desc: t(SFSportsRecoveryBenefit1),
        },
        {
          desc: t(SFSportsRecoveryBenefit2),
        },
        {
          desc: t(SFSportsRecoveryBenefit3),
        },
      ],
      ingredients: SPORT_RECOVERY_INGREDIENTS,
      howToTake: [
        "One pouch a day, once a day, that's it!",
        "You can take it directly in your mouth followed by a sip of water or mix it with a yoghurt!",
      ],
    },
    beauty: {
      name: t(BeautyFA),
      images: [
        { en: Beauty, de: Beauty },
        { en: BeautyImage2, de: BeautyImage2De },
        { en: ReviewImage, de: ReviewImageDe },
        { en: HowToTakeImage, de: HowToTakeImageDe },
      ],
      heading: t(SFBeautyTitle),
      desc: t(SFBeautyDesc),
      price: 32,
      link: "https://buy.stripe.com/00g9BUbar737eGsaUo",
      benefits: [
        {
          desc: t(SFBeautyBenefit1),
        },
        {
          desc: t(SFBeautyBenefit2),
        },
        {
          desc: t(SFBeautyBenefit3),
        },
      ],
      ingredients: BEAUTY_INGREDIENTS,
      howToTake: [
        "One pouch a day, once a day, that's it!",
        "You can take it directly in your mouth followed by a sip of water or mix it with a yoghurt!",
      ],
    },
    "immune-system": {
      name: t(ImmuneSystemFA),
      images: [
        { en: ImmuneSystem, de: ImmuneSystem },
        { en: ImmuneImage2, de: ImmuneImage2De },
        { en: ImmuneImage3, de: ImmuneImage3De },
        { en: HowToTakeImage, de: HowToTakeImageDe },
      ],
      heading: t(SFImmuneSystemTitle),
      desc: t(SFImmuneSystemDesc),
      price: 39,
      link: "https://buy.stripe.com/fZe7tMfqHfzD0PC1jP",
      benefits: [
        {
          desc: t(SFImmuneSystemBenefit1),
        },
        {
          desc: t(SFImmuneSystemBenefit2),
        },
        {
          desc: t(SFImmuneSystemBenefit3),
        },
      ],
      ingredients: IMMUNE_SYSTEM_INGREDIENTS,
      howToTake: [
        "One pouch a day, once a day, that's it!",
        "You can take it directly in your mouth followed by a sip of water or mix it with a yoghurt!",
      ],
    },
  };
  return { SMART_FORMULAS };
};

export default useSmartFornula;
